export default __webpack_public_path__ + "static/media/slovenia.b74914ff.svg";